export default __webpack_public_path__ + "static/media/Avatar-8.cb105b37.png";